
export function OnDocumentListSelectionChanged(grid: MVCxClientGridView, event) {

    let rowCount = grid.GetSelectedRowCount();

    $('.gridaction.download').toggleClass('disabled', rowCount !== 1);
    $('.gridaction.edit').toggleClass('disabled', rowCount !== 1);
    $('.gridaction.search').toggleClass('disabled', rowCount !== 1);
    $('.gridaction.del').toggleClass('disabled', rowCount === 0);
    $('.gridaction.share').toggleClass('disabled', rowCount === 0);
}
